export const getGrid = (id) => ({
  type: 'GET_GRID',
  id
})



// WEBPACK FOOTER //
// ./src/actions/grids.js